import { CollectionStore } from 'modules/base';

export class FocusAreasStore extends CollectionStore {
  baseUrl = '/focus-areas';
}
